import { render, staticRenderFns } from "./BrokerList.vue?vue&type=template&id=d0d31178"
import script from "./BrokerList.vue?vue&type=script&lang=js"
export * from "./BrokerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports